import React from 'react';
import _ from 'lodash';

import InputCurrencyField from '../../Fields/InputCurrencyField';

import withInvoice from '../../Common/WithInvoice';
import { LineItemEntryInput } from '../../../Entities/LineItemEntry';
import '../../Fields/InvoiceLineItemEntryTableRow.scss';

class InvoiceTotalSummaryTableRow extends React.Component {

  render() {
    const { type, lineItemEntryRow, inputId, negativeMode, editMode, handleLineItemChange, totalRow } = this.props;

    const lineItemEntry =
      lineItemEntryRow?.fields.entries.value.find(
        (entry) => entry.fields.created_at.value === null
      ) || new LineItemEntryInput();
    const grossAmount = lineItemEntry.getGrossAmount();
    const entryType = type;

    return (
      <div className='parkchirp--invoice-total-summary-table-row'>
        <div
          className='parkchirp--invoice-line-item-entry-table--type-column parkchirp--invoice-line-item-entry-table--cell'
        >
          <span>{entryType}</span>
        </div>
        <div
          className='parkchirp--invoice-line-item-entry-table--net-amount-column parkchirp--invoice-line-item-entry-table--cell'
        >
          <InputCurrencyField
            inputId={`${inputId}--amount`}
            value={lineItemEntry.fields.amount.value || 0}
            key={`amount--${lineItemEntry.fields.amount.value}`}
            onChange={(value) => handleLineItemChange('amount', value)}
            editMode={editMode}
            negativeMode={negativeMode}
            specialCharCheck={true}
            disabledMode={editMode ? totalRow.fields.amount?.value === 0 : false}
          />
        </div>
        <div
          className='parkchirp--invoice-line-item-entry-table--amount-tax-1-column parkchirp--invoice-line-item-entry-table--cell'
        >
          <InputCurrencyField
            inputId={`${inputId}--amount-tax-1`}
            value={lineItemEntry.fields.amount_tax_1.value || 0}
            key={`amount-tax-1--${lineItemEntry.fields.amount_tax_1.value}`}
            onChange={(value) => handleLineItemChange('amount_tax_1', value)}
            editMode={editMode}
            negativeMode={negativeMode}
            specialCharCheck={true}
            disabledMode={editMode ? totalRow.fields.amount_tax_1?.value === 0 : false}
          />
        </div>
        <div
          className='parkchirp--invoice-line-item-entry-table--amount-tax-2-column parkchirp--invoice-line-item-entry-table--cell'
        >
          <InputCurrencyField
            inputId={`${inputId}--amount-tax-2`}
            value={lineItemEntry.fields.amount_tax_2.value || 0}
            key={`amount-tax-2--${lineItemEntry.fields.amount_tax_2.value}`}
            onChange={(value) => handleLineItemChange('amount_tax_2', value)}
            editMode={editMode}
            negativeMode={negativeMode}
            specialCharCheck={true}
            disabledMode={editMode ? totalRow.fields.amount_tax_2?.value === 0 : false}
          />
        </div>
        <div
          className='parkchirp--invoice-line-item-entry-table--amount-tax-3-column parkchirp--invoice-line-item-entry-table--cell'
        >
          <InputCurrencyField
            inputId={`${inputId}--amount-tax-3`}
            value={lineItemEntry.fields.amount_tax_3.value || 0}
            key={`amount-tax-3--${lineItemEntry.fields.amount_tax_3.value}`}
            onChange={(value) => handleLineItemChange('amount_tax_3', value)}
            editMode={editMode}
            negativeMode={negativeMode}
            specialCharCheck={true}
            disabledMode={editMode ? totalRow.fields.amount_tax_3?.value === 0 : false}
          />
        </div>
        <div
          className='parkchirp--invoice-line-item-entry-table--amount-tax-4-column parkchirp--invoice-line-item-entry-table--cell'
        >
          <InputCurrencyField
            inputId={`${inputId}--amount-tax-4`}
            value={lineItemEntry.fields.amount_tax_4.value || 0}
            key={`amount-tax-4--${lineItemEntry.fields.amount_tax_4.value}`}
            onChange={(value) => handleLineItemChange('amount_tax_4', value)}
            editMode={editMode}
            negativeMode={negativeMode}
            specialCharCheck={true}
            disabledMode={editMode ? totalRow.fields.amount_tax_4?.value === 0 : false}
          />
        </div>
        <div
          className='parkchirp--invoice-line-item-entry-table--gross-amount-column parkchirp--invoice-line-item-entry-table--cell'
        >
          <InputCurrencyField
            inputId={`${inputId}--gross-amount`}
            value={grossAmount}
            key={`gross-amount--${lineItemEntry.fields.gross_amount.value}`}
            editMode={false}
            negativeMode={negativeMode}
          />
        </div>
      </div>
    );
  }
}

export default withInvoice(InvoiceTotalSummaryTableRow);
